import { DocPart } from './doc-part';

export class DocTemplate {
  id: number;
  name: string;
  check_number: number;
  description: string;
  is_global: boolean;
  require_proof: boolean = false;
  require_envelope: boolean = false;
  send_check: boolean = false;
  matter_type_id: number;
  matter_id: number;
  activity_id: number;
  payee: number;
  amount: number;
  document_type_id: number;
  is_letter: boolean = false;
  notes: string;
  logo_id: number;
  watermark_start_page: number;
  doc_parts: Array<DocPart> = [new DocPart()];
  tag_list: any;
  class_name: string;
  doc_parts_size: number = 0;
  documents_size: number = 0;
  document_type_prefix: string;
  stylesheets: Array<any> = [];
  merge_parts: boolean = false;
  saving: boolean = false;
  deleting: boolean = false;
}
